import type { StateCreator } from 'zustand';

export interface GenerationSlice {
  isGenerating: boolean;
  setIsGenerating: (generating: boolean) => void;
  generationId: string | null;
  setGenerationId: (id: string | null) => void;
  generationError: string | null;
  setGenerationError: (error: string | null) => void;
  isPrimaryActionLoading: boolean;
  setIsPrimaryActionLoading: (loading: boolean) => void;
  generationProgress: number;
  setGenerationProgress: (progress: number) => void;
  generationStartTime: number | null;
  setGenerationStartTime: (time: number | null) => void;
}

export const generationInitialState = {
  isGenerating: false,
  generationId: null as string | null,
  generationError: null as string | null,
  isPrimaryActionLoading: false,
  generationProgress: 0,
  generationStartTime: null as number | null,
};

export const createGenerationSlice: StateCreator<
  GenerationSlice,
  [],
  [],
  GenerationSlice
> = (set) => ({
  ...generationInitialState,

  setIsGenerating: (isGenerating) => set({ isGenerating }),
  setGenerationId: (generationId) => set({ generationId }),
  setGenerationError: (generationError) => set({ generationError }),
  setIsPrimaryActionLoading: (isPrimaryActionLoading) =>
    set({ isPrimaryActionLoading }),
  setGenerationProgress: (generationProgress) => set({ generationProgress }),
  setGenerationStartTime: (generationStartTime) => set({ generationStartTime }),
});
